import {createElement} from 'rlink-react';
import AgeGate from 'rlink-agegate/components/AgeGate';

import AgeGateTheme from 'theme/rlink-agegate/AgeGate.less';

export default function AgeGateView (params) {
  return (
    <AgeGate
      {...params}
      selectedMonth={0}
      selectedDay={1}
      theme={AgeGateTheme} />
  );
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/agegate.jsx